import React from 'react';
import { useTranslation } from 'react-i18next';

export default function DateSelection({
    dates,
    selectedDate,
    setSelectedDate,
    setDateStr,
    setSelectedTime,
    setSelectedArtistId
}) {
    const { t } = useTranslation();

    const handleSelectDate = (d) => {
        if (d.closed) return;
        setSelectedDate(d.value);
        setDateStr(d.value); // triggers API fetch for times
        setSelectedTime(null);
        setSelectedArtistId(null);
    };

    return (
        <div style={{ marginBottom: '3rem' }}>
            <h2 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '1.8rem', letterSpacing: '0.06em', color: '#ffffff', marginBottom: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <span style={{ fontFamily: "'Oswald', sans-serif", fontSize: '0.9rem', fontWeight: 700, color: 'var(--orange)', border: '2px solid var(--orange)', borderRadius: '50%', width: '32px', height: '32px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>2</span>
                {t('booking.selectDate')}
            </h2>

            <div style={{
                display: 'flex', gap: '0.75rem', overflowX: 'auto', paddingBottom: '1rem',
                scrollbarWidth: 'thin', scrollbarColor: 'var(--border) transparent'
            }}>
                {dates.map((d, i) => {
                    const isSelected = selectedDate === d.value;
                    return (
                        <div
                            key={i}
                            onClick={() => handleSelectDate(d)}
                            style={{
                                flex: '0 0 auto',
                                width: '80px',
                                padding: '1rem 0.5rem',
                                borderRadius: '12px',
                                background: d.closed ? 'rgba(239, 68, 68, 0.05)' : isSelected ? 'var(--orange)' : 'var(--bg-card)',
                                color: isSelected ? '#18181b' : '#ffffff',
                                border: `1px solid ${d.closed ? 'rgba(239, 68, 68, 0.2)' : isSelected ? 'var(--orange)' : 'var(--border)'}`,
                                cursor: d.closed ? 'not-allowed' : 'pointer',
                                textAlign: 'center',
                                transition: 'all 0.2s',
                                position: 'relative',
                                opacity: d.closed ? 0.6 : 1
                            }}
                        >
                            <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600, opacity: isSelected ? 0.8 : 0.6, marginBottom: '0.2rem' }}>
                                {d.label}
                            </div>
                            <div style={{ fontSize: '1.6rem', fontWeight: 700, fontFamily: "'Oswald', sans-serif", lineHeight: 1 }}>
                                {d.day}
                            </div>
                            <div style={{ fontSize: '0.7rem', opacity: isSelected ? 0.8 : 0.6, marginTop: '0.2rem' }}>
                                {d.month}
                            </div>
                            {d.closed && (
                                <div style={{ position: 'absolute', top: -8, right: -8, background: '#ef4444', color: '#fff', fontSize: '0.6rem', padding: '2px 6px', borderRadius: '10px', border: '2px solid var(--bg-base)' }}>
                                    {t('booking.closed')}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
